'use client';

import Container from '@mui/material/Container';

import { paths, newSearchParams } from 'src/routes/paths';

import { useTranslate } from 'src/locales';

import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';

import { ProductNewEditForm } from '../product-new-edit-form';

// ----------------------------------------------------------------------

export function ProductEditView({ product }) {
  const { t, currentLang } = useTranslate();

  return (
    <Container sx={{ mb: 12 }}>
      <CustomBreadcrumbs
        heading={t('Edit')}
        links={[
          {
            name: t('Promotions'),
            href: `${paths.promotions}${newSearchParams({ country: currentLang.countryName })}`,
          },
          { name: product?.name },
        ]}
        sx={{ mt: { xs: 3, md: 5 }, mb: { xs: 3, md: 5 } }}
      />

      <ProductNewEditForm currentProduct={product} />
    </Container>
  );
}
